import React, { useRef } from "react";

type GlobalMode = "GESTURE" | "TOUCH"

const powerUpVerification = (
  videoRef: React.RefObject<HTMLVideoElement>,
  signHeld: boolean,
  setSignHeld: React.Dispatch<React.SetStateAction<boolean>>,
  detectionRef: React.RefObject<boolean | null>,
  intervalRef: NodeJS.Timeout | null,
  setIntervalRef: React.Dispatch<React.SetStateAction<NodeJS.Timeout | null>>,
  intervalRewind: React.MutableRefObject<NodeJS.Timeout | null>,
  usingMode: GlobalMode,
  isHolding: React.RefObject<boolean | null>,
) => {
  let playBackwards = function (video: HTMLVideoElement) {
    if (intervalRewind.current) return;

    console.log("INTERVAL REWIND START", { detectionRef: detectionRef.current });

    video.pause();
    const fps = 30;

    intervalRewind.current = setInterval(() => {
      video.currentTime -= 1 / fps;

      if (detectionRef.current) {
        console.log("DETECTED SIGN, STOPPING REWIND");
        clearInterval(intervalRewind.current!);
        intervalRewind.current = null;
        video.play();
      }

      if (video.currentTime <= 0) {
        clearInterval(intervalRewind.current!);
        intervalRewind.current = null;
        video.pause();
      }
    }, 500 / fps);
  };

  if (!videoRef.current) return;
  const video = videoRef.current;

  if ((detectionRef.current || isHolding.current ) && signHeld) {
    video.play();
  }

  if (intervalRef) return;

  const interval = setInterval(() => {
    // console.log("CHECKING", {
    //   time: video.currentTime,
    //   detection: detectionRef.current,
    //   signHeld,
    //   isHolding:isHolding.current
    // });

    if ( (detectionRef.current || isHolding.current ) && signHeld) {
      video.play();
    }

    if (video.currentTime <= 0.1) {
      video.currentTime = 0;
      clearInterval(interval);
      setIntervalRef(null);
      setSignHeld(false);
    }

    if (video.currentTime >= 0 && (!detectionRef.current && !isHolding.current)) {
      playBackwards(video);
    }
  }, 500);

  setIntervalRef(interval);
};

export default powerUpVerification;
